<mat-dialog-content>
  <h3>Kundennummer wechseln</h3>
  @if (customers(); as customers) {
    <mat-radio-group>
      @for (customer of customers; track customer.id) {
        <mat-radio-button
          (change)="customerChecked(customer)"
          [value]="customer.id"
          [checked]="current()?.id === customer.id"
          labelPosition="after">
          <span class="label">
            <span>{{ customer.id }} - {{ customer.address?.streetAddress }}</span>
            <span class="alias">{{ customer.alias }}</span>
          </span>
        </mat-radio-button>
      }
    </mat-radio-group>
  }
</mat-dialog-content>
<mat-dialog-actions align=end class="dialog-actions">
  <ui-button (click)="closeDialog()" buttonStyle="outlined">Abbrechen</ui-button>
  <ui-button (click)="closeDialog(checked())" buttonStyle="filled">Speichern</ui-button>
</mat-dialog-actions>
